import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "layout" }
const _hoisted_2 = { class: "layout__wrapper" }
const _hoisted_3 = { class: "article-single background-section" }
const _hoisted_4 = { class: "container article-single__content control-container" }

import Sidebar from '@/app/components/doc/reading/Sidebar.vue'
import HeaderBook from '@/app/components/doc/Header.vue'
import BackLink from '@/app/components/BackLink.vue'
import Footer from '@/app/components/Footer.vue'

import PrevNext from './PrevNext.vue'
import ArticleThread from './Thread.vue'

import { ArticleView } from '@/models/doc.article'


export default /*@__PURE__*/_defineComponent({
  __name: 'Layout',
  props: {
    article: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(HeaderBook, { doc: __props.article }, null, 8, ["doc"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(BackLink, { class: "article-single__backlink" }),
          _createVNode(Sidebar, { doc: __props.article }, null, 8, ["doc"]),
          _renderSlot(_ctx.$slots, "default"),
          _createVNode(PrevNext, { article: __props.article }, null, 8, ["article"]),
          _createVNode(ArticleThread, { article: __props.article }, null, 8, ["article"])
        ])
      ])
    ]),
    _createVNode(Footer)
  ]))
}
}

})